import * as THREE from 'three';

const assembly = {
  board: new THREE.MeshBasicMaterial({
    color: 0x332B17,
    order: 0,
  }),
  bottomsilkscreen: new THREE.MeshBasicMaterial({
    color: 0xffffff,
  }),
  bottomsoldermask: new THREE.MeshBasicMaterial({
    color: 0x006600,
    opacity: 0.75,
    transparent: true,
  }),
  topsilkscreen: new THREE.MeshBasicMaterial({
    color: 0xffffff,
    order: 3,
  }),
  topsoldermask: new THREE.MeshBasicMaterial({
    color: 0x006600,
    opacity: 0.75,
    transmission: 0.75,
    transparent: true,
    order: 2,
  }),
  partSelected: new THREE.MeshStandardMaterial({
    color: 0xFF0000,
    opacity: 0.60,
    transparent: true,
    order: 4,
  }),
  partPlaced: new THREE.MeshStandardMaterial({
    color: 0x666666,
    opacity: 1.0,
    transparent: false,
    order: 4,
  }),
  partNotPlaced: new THREE.MeshStandardMaterial({
    color: 0xEEEEEE,
    opacity: 0.60,
    transparent: true,
    order: 4,
  }),
  note: new THREE.MeshBasicMaterial({ color: 0xFF2222 }),
  pin1: new THREE.MeshBasicMaterial({ color: 0x4990E9 }),
};

const assemblyHasl = {
  ...assembly,
  bottomlayer: new THREE.MeshBasicMaterial({
    color: 0xA9A9A9,
  }),
  toplayer: new THREE.MeshBasicMaterial({
    color: 0xA9A9A9,
    order: 1,
  }),
  drills: new THREE.MeshBasicMaterial({
    color: 0xA9A9A9,
  }),
};

const assemblyEnig = {
  ...assembly,
  bottomlayer: new THREE.MeshBasicMaterial({
    color: 0xFFBD00,
  }),
  toplayer: new THREE.MeshBasicMaterial({
    color: 0xFFBD00,
  }),
  drills: new THREE.MeshBasicMaterial({
    color: 0xFFBD00,
  }),
};

// Use KiCad colors for layers (https://github.com/pointhi/kicad-color-schemes/blob/master/kicad-2020/kicad_2020.json)
const copperLayerColors = {
  bottomlayer: 'rgb(77, 127, 196)',
  toplayer: 'rgb(200, 52, 52)',
  internalplane1: 'rgb(127, 200, 127)',
  internalplane2: 'rgb(206, 125, 44)',
  internalplane3: 'rgb(79, 203, 203)',
  internalplane4: 'rgb(219, 98, 139)',
  internalplane5: 'rgb(167, 165, 198)',
  internalplane6: 'rgb(40, 204, 217)',
  internalplane7: 'rgb(232, 178, 167)',
  internalplane8: 'rgb(242, 237, 161)',
  internalplane9: 'rgb(141, 203, 129)',
  internalplane10: 'rgb(237, 124, 51)',
  internalplane11: 'rgb(91, 195, 235)',
  internalplane12: 'rgb(247, 111, 142)',
  internalplane13: 'rgb(167, 165, 198)',
  internalplane14: 'rgb(40, 204, 217)',
  internalplane15: 'rgb(232, 178, 167)',
  internalplane16: 'rgb(242, 237, 161)',
  internalplane17: 'rgb(237, 124, 51)',
  internalplane18: 'rgb(91, 195, 235)',
  internalplane19: 'rgb(247, 111, 142)',
  internalplane20: 'rgb(167, 165, 198)',
  internalplane21: 'rgb(40, 204, 217)',
  internalplane22: 'rgb(232, 178, 167)',
  internalplane23: 'rgb(242, 237, 161)',
  internalplane24: 'rgb(237, 124, 51)',
  internalplane25: 'rgb(91, 195, 235)',
  internalplane26: 'rgb(247, 111, 142)',
  internalplane27: 'rgb(167, 165, 198)',
  internalplane28: 'rgb(40, 204, 217)',
  internalplane29: 'rgb(232, 178, 167)',
  internalplane30: 'rgb(242, 237, 161)',
};

const materials = {
  board: new THREE.MeshBasicMaterial({ color: '#666666' }),

  boardoutline: new THREE.LineBasicMaterial({ color: new THREE.Color('rgb(255,165,0)'), linewidth: 1.0 }),

  topsilkscreen: new THREE.MeshBasicMaterial(),
  bottomsilkscreen: new THREE.MeshBasicMaterial(),

  topsoldermask: new THREE.MeshBasicMaterial({
    color: new THREE.Color('rgb(216, 222, 233)'),
    opacity: 0.25,
    transparent: true,
  }),
  bottomsoldermask: new THREE.MeshBasicMaterial({
    color: new THREE.Color('rgb(216, 222, 233)'),
    opacity: 0.25,
    transparent: true,
  }),

  holes: new THREE.MeshBasicMaterial({
    color: '#4990E9',
  }),
  drills: new THREE.MeshBasicMaterial({
    color: new THREE.Color('rgb(216, 222, 233)'),
  }),

  millinglv1: new THREE.MeshBasicMaterial({
    color: new THREE.Color('rgb(148, 80, 160)'),
    opacity: 0.85,
    transparent: true,
  }),
  millinglv2: new THREE.MeshBasicMaterial({
    color: new THREE.Color('rgb(148, 80, 160)'),
    opacity: 0.95,
    transparent: true,
  }),

  note: new THREE.MeshBasicMaterial({ color: '#FF4444' }),
};

for (const [key, color] of Object.entries(copperLayerColors)) {
  materials[key] = new THREE.MeshBasicMaterial({
    color: new THREE.Color(color),
    opacity: 0.85,
    transparent: true,
  });
}

const layoutStackedLayers = materials;

const layoutReal = {
  board: new THREE.MeshBasicMaterial({
    color: 0x5d4a1b,
  }),
  boardoutline: new THREE.MeshBasicMaterial({
    color: 0x666666,
  }),
  topsilkscreen: new THREE.MeshBasicMaterial({
    color: 0xFFFFFF,
  }),
  bottomsilkscreen: new THREE.MeshBasicMaterial({
    color: 0xFFFFFF,
  }),
  topsoldermask: new THREE.MeshBasicMaterial({
    color: 0x006600,
    opacity: 0.75,
    transparent: true,
  }),
  bottomsoldermask: new THREE.MeshBasicMaterial({
    color: 0x006600,
    opacity: 0.75,
    transparent: true,
  }),
  toppaste: new THREE.MeshBasicMaterial({
    color: 0x666666,
    opacity: 0.9,
    transparent: true,
  }),
  bottompaste: new THREE.MeshBasicMaterial({
    color: 0x666666,
    opacity: 0.9,
    transparent: true,
  }),
  holes: new THREE.MeshBasicMaterial({
    color: '#4990E9',
    opacity: 0.75,
    transparent: true,
  }),
  millinglv1: new THREE.MeshBasicMaterial({
    color: new THREE.Color('rgb(148, 80, 160)'),
    opacity: 0.85,
    transparent: true,
  }),
  millinglv2: new THREE.MeshBasicMaterial({
    color: new THREE.Color('rgb(148, 80, 160)'),
    opacity: 0.95,
    transparent: true,
  }),
  note: new THREE.MeshBasicMaterial({ color: 0xFF4444 }),
  measurement: new THREE.MeshBasicMaterial({ color: 0xededed }),
};

const layoutRealHasl = {
  ...layoutReal,
  toplayer: new THREE.MeshStandardMaterial({
    color: 0xA9A9A9,
  }),
  bottomlayer: new THREE.MeshStandardMaterial({
    color: 0xA9A9A9,
  }),
  drills: new THREE.MeshStandardMaterial({
    color: 0xA9A9A9,
  }),
};

const layoutRealEnig = {
  ...layoutReal,
  toplayer: new THREE.MeshStandardMaterial({
    color: 0xFFBD00,
  }),
  bottomlayer: new THREE.MeshStandardMaterial({
    color: 0xFFBD00,
  }),
  drills: new THREE.MeshStandardMaterial({
    color: 0xFFBD00,
  }),
};

export default {
  assembly,
  assemblyHasl,
  assemblyEnig,
  layoutStackedLayers,
  layoutReal,
  layoutRealEnig,
  layoutRealHasl,
};
